export * from './script/index'